


































import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter, State, Mutation } from 'vuex-class';
import ToolBar from '@/views/components/dashboard/tool-bar.vue';
import ToolGroup from '@/views/components/dashboard/tool-group.vue';
import ToolNav from '@/views/components/dashboard/tool-nav.vue';
import DashboardItem from '@/views/components/dashboard/dashboard-item.vue';
import DashboardComp from '@/views/components/dashboard/dashboard-comp.vue';

@Component({
  components: {
    ToolBar,
    ToolGroup,
    ToolNav,
    DashboardItem,
    DashboardComp,
  },
})
export default class Dashboard extends Vue {
  @State('rocketbot') private rocketGlobal: any;
  @State('rocketOption') private stateDashboardOption!: any;
  @State('rocketData') private rocketComps!: any;
  @Mutation('SET_EVENTS') private SET_EVENTS: any;
  @Mutation('SET_COMPS_TREE') private SET_COMPS_TREE: any;
  @Mutation('SET_CURRENT_COMPS') private SET_CURRENT_COMPS: any;
  @Action('MIXHANDLE_GET_OPTION') private MIXHANDLE_GET_OPTION: any;
  @Action('GET_QUERY') private GET_QUERY: any;
  @Getter('durationTime') private durationTime: any;
  private isRouterAlive: boolean = true;
  private dragIndex: number = NaN;
  public dragStart(index: number) {
    this.dragIndex = index;
  }
  public reload(): void {
    this.isRouterAlive = false;
    this.$nextTick(() => { this.isRouterAlive = true; });
  }
  private get compType() {
    return this.rocketComps.tree[this.rocketComps.group].type;
  }
  private handleRefresh() {
    this.GET_QUERY({
      serviceId: this.stateDashboardOption.currentService.key || '',
      endpointId: this.stateDashboardOption.currentEndpoint.key || '',
      endpointName: this.stateDashboardOption.currentEndpoint.label || '',
      instanceId: this.stateDashboardOption.currentInstance.key || '',
      databaseId: this.stateDashboardOption.currentDatabase.key || '',
      duration: this.durationTime,
    });
  }
  private handleOption() {
    return this.MIXHANDLE_GET_OPTION({compType: this.compType, duration: this.durationTime})
      .then(() => {this.handleRefresh(); });
  }
  // private beforeCreate() {
  //   this.$store.registerModule('rocketDashboard', dashboard);
  // }
  private beforeMount() {
    if (window.localStorage.getItem('dashboard')) {
      const data: string = `${window.localStorage.getItem('dashboard')}`;
      this.SET_COMPS_TREE(JSON.parse(data));
    }
    this.handleOption();
    this.SET_EVENTS([this.handleRefresh]);
  }
  // private beforeDestroy() {
  //   this.$store.unregisterModule('rocketDashboard');
  // }
}
